module.exports = __webpack_public_path__ + "img/cover.3d05cc7b.jpg";